import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function AppDirection() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const isArabic = i18n.language?.startsWith("ar");

    document.documentElement.lang = isArabic ? "ar" : "en";
    document.documentElement.dir = isArabic ? "rtl" : "ltr";

    // Body helper classes (you already use these)
    document.body.classList.toggle("rtl", isArabic);
    document.body.classList.toggle("ltr", !isArabic);

    // ✅ Add these (global font switching hook)
    document.documentElement.classList.toggle("lang-ar", isArabic);
    document.documentElement.classList.toggle("lang-en", !isArabic);
  }, [i18n.language]);

  return null;
}